import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Services', href: '/#services' },
    { name: 'Case Studies', href: '/#case-studies' },
    { name: 'Testimonials', href: '/#testimonials' },
    { name: 'Insights', href: '/#blog' },
  ];

  return (
    <header className="dark-header">
      <div className="flex items-center justify-between w-full max-w-[1400px] mx-auto">
        {/* Logo — slash-prefix terminal style */}
        <a href="/" className="flex items-center cursor-pointer no-underline" style={{ letterSpacing: '1px' }}>
          <span className="text-brand-primary font-bold text-base leading-none">/</span>
          <span className="text-text-primary font-bold text-base leading-none tracking-wider">FALCON42</span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1 ml-8">
          {navLinks.map((link) => (
            <a key={link.name} href={link.href} className="dark-nav-link">
              {link.name}
            </a>
          ))}
        </nav>

        {/* Right side CTA */}
        <div className="hidden md:flex items-center gap-2 ml-auto">
          <a
            href="/#contact"
            className="btn-primary"
            style={{ fontSize: '10px', padding: '6px 16px' }}
          >
            Book Consult
          </a>
        </div>

        {/* Mobile Toggle */}
        <button
          className="md:hidden text-text-secondary ml-auto p-1 border border-border-medium"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="absolute top-[48px] left-0 w-full bg-bg-primary border-b border-border-medium p-6 flex flex-col gap-4 md:hidden animate-accordion-down z-40">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="dark-nav-link"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {link.name}
            </a>
          ))}
          <a
            href="/#contact"
            className="btn-primary justify-center"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Book Consultation
          </a>
        </div>
      )}
    </header>
  );
}
